<template>
  <div class="login-page">
    <header class="navy">
      <nav>
        <div class="logo">
          <a href="#" style="margin-right: 2rem;" @click.prevent="$router.push('/')">
            <img src="@/assets/img/giupnuri_logo.png"/>
          </a>
          <!--Menu-->
          <!--          <div class="menu">-->
          <!--            <ul>-->
          <!--              <li>-->
          <!--                <a href="#">-->
          <!--                  제품소개-->
          <!--                </a>-->
          <!--              </li>-->
          <!--              <li>-->
          <!--                <a href="#">-->
          <!--                  고객사례-->
          <!--                </a>-->
          <!--              </li>-->
          <!--              <li>-->
          <!--                <a href="#">-->
          <!--                  서비스 문의-->
          <!--                </a>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </div>-->
        </div>
        <div class="sign">
          <ul>
            <li>
              <a href="#" @click.prevent="$router.push('/account/sign')">
                회원가입
              </a>
            </li>
            <li>
              <a href="#" @click.prevent="$router.push('/account/login')">
                로그인
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!--end::header-->
    <section>
      <article>
        <div class="login_box">
          <div class="login_img">
            <img src="@/assets/img/login.png" alt="">
          </div>
          <div class="login_text">
            <h1>계정 찾기</h1>
            <div class="tab_bar">
              <button class="on">아이디 찾기</button>
              <button @click="$router.replace('/account/findPWD')">비밀번호 찾기</button>
            </div>
            <div class="login_form">
              <form>
                <div class="id with-button">
                  <input type="text" name="name" v-model="params.contactPhone">
                  <span>휴대폰 번호</span>
                  <button type="button" @click="sendPhoneAuth">{{ sendPhoneAuthText }}</button>
                </div>
                <div class="password with-button addon" v-if="isSendAuth">
                  <input type="text" name="name" v-model="params.authCode" :readonly="isConfirmAuth">
                  <span>인증코드</span>
                  <span class="count" v-show="!isConfirmAuth">{{ timer }}</span>
                  <button type="button" @click="confirmPhoneAuthCode" :disabled="isConfirmAuth">확인</button>
                </div>
              </form>
              <div class="result" v-if="!$Util.isEmpty(result)">
                회원님의 아이디는 <span>{{ result }}</span> 입니다.
              </div>
              <div class="btn">
                <button type="button" @click="findUserID">아이디 찾기</button>
              </div>
            </div>
            <div class="signup">
              <div class="id_pw">
                <a href="#" @click.prevent="$router.push('/account/login')">
                  로그인
                </a>
              </div>
              <div>
                <a href="#" @click.prevent="$router.push('/account/sign')">
                  회원가입
                </a>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>

    <layout-footer></layout-footer>

  </div>
</template>
<script>
import required from "vuelidate/lib/validators/required";

export default {
  data: function () {
    return {
      expired: false,
      timer: '5:00',
      sendPhoneAuthText: '인증',
      countDownInterval: null,
      isSendAuth: false,
      isConfirmAuth: false,
      result: '',
      params: {
        contactPhone: '',
      }
    }
  },
  watch: {
    'params.contactPhone': function () {
      this.isConfirmAuth = false
      this.params.authCode = ''
      this.timer = '5:00'
      this.isSendAuth = false
    }
  },
  methods: {
    sendPhoneAuth: function () {
      this.isSendAuth = true
      this.countDown()
      if (this.params.contactPhone.length <= 0) {
        alert('휴대폰번호를 입력해주세요.')
        return false
      }

      if (!this.$Util.isPhoneValid(this.params.contactPhone)) {
        alert('올바른 휴대폰번호를 입력해주세요.')
        return false
      }

      this.$CommonSvc.sendPhoneAuth({contactPhone: this.params.contactPhone, authType: 2})
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            alert('인증코드가 발송 되었습니다.')
            this.params.authToken = entity.authToken
            this.params.authCode = ''
            this.isConfirmAuth = false
            this.isSendAuth = true
            this.sendPhoneAuthText = '재인증'
            this.expired = false
            this.timer = '5:00'
            this.countDown()
          } else {
            alert(message)
          }
        })
    },
    countDown: function () {
      clearInterval(this.countDownInterval)
      let duration = this.$moment.duration({
        'minutes': '5',
        'seconds': '00'
      })
      const _this = this
      this.countDownInterval = setInterval(function () {
        duration = _this.$moment.duration(duration.asSeconds() - 1, 'seconds')
        let min = duration.minutes()
        let sec = duration.seconds()
        if (Number(sec) < 0) {
          _this.timer = '0:00'
          _this.expired = true
          clearInterval(_this.countDownInterval)
          return false
        }
        if (sec < 10) {
          sec = '0' + sec
        }

        _this.timer = min + ':' + sec
      }, 1000)
    },
    confirmPhoneAuthCode: function () {
      if (this.expired) {
        alert('인증시간이 만료되었습니다.\n재 인증 해주세요.')
        return false
      }

      if (this.params.authCode.length <= 0) {
        alert('인증코드를 입력해주세요.')
        return false
      }

      let params = {
        userPhone: this.params.userPhone,
        authCode: this.params.authCode,
        authToken: this.params.authToken
      }

      this.$CommonSvc.confirmPhoneAuthCode(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log(entity)
          if (code === 1) {
            alert('인증 되었습니다.')
            this.isConfirmAuth = true
            clearInterval(this.countDownInterval)
          } else {
            alert(message)
          }
        })
    },
    findUserID: function () {
      if (!this.isConfirmAuth) {
        alert('인증절차를 완료 해주세요.')
        return false
      }

      this.$AccountSvc.findUserID(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            this.result = entity
          } else {
            alert(message)
          }
        })
    }
  }
}
</script>
